import '../css/index.less';
var _index = {
  init(){
    $('.g-slick').on('init', function(event, slick){
      $('.g-slick img').eq(0).attr('src', $('.g-slick img').eq(0).data('src'));
    });
    $('.g-slick').slick({
      infinite:false,
      dots: true
    });
    $('.g-slick').on('afterChange', function(){
      var _index = $('.g-slick').slick('slickCurrentSlide');
      $('.g-slick img').eq(_index).attr('src', $('.g-slick img').eq(_index).data('src'));
    });
  },
  Close(){
    var that = this;
    $('.modal').on('click', '.close', () =>{
        that.modalClose();
    });
  },
  modalOpen(modal_target, bool=true){
    let $bool = bool;
    let $modal_target = (typeof modal_target) === 'string'? $(modal_target) : modal_target;
    if($bool){
      var _right = this.getScrollWidth();
      $('body').addClass('modal-open').css('padding-right', _right).append('<div class="modal-backdrop fade in"></div>');
      $($modal_target).css('display', 'block');
      $($modal_target).css('display');
      $($modal_target).css({
          'paddingRight': _right
      }).addClass('in');
    }else{
      $($modal_target).css('display', 'block');
      $($modal_target).css('display');
      $($modal_target).css({
          'paddingRight': _right
      }).addClass('in');
    }
    
  },
  modalClose(bool=true){
    let $bool = bool;
    if($bool){
      $('.modal').removeClass('in');
      $('.modal-backdrop').removeClass('in');
      setTimeout(() =>{
          $('.modal').attr('style', '');
          $('.modal-backdrop').remove();
          $('body').removeClass('modal-open').attr('style', '');
      }, 100);
    }else{
      $('.modal').attr('style', '');
      $('.modal').removeClass('in');
    }
  },
  getScrollWidth(){
    return (window.innerWidth - document.body.clientWidth);
  },
  HmtBaiDu(){
    var _hmt = _hmt || [];
		(function() {
			var hm = document.createElement("script");
			hm.src = "//hm.baidu.com/hm.js?1597dca1f94a64fca0543d468b7ef7d9";
			var s = document.getElementsByTagName("script")[0];
			s.parentNode.insertBefore(hm, s);
		})();
  },
  VerifyFormat(eml='#j_user_info'){
    var that = this;
    var $from = $(eml);
    var $required = $from.find('[required]');
    //智能清除提示 
    $required.on('input propertychange', function(){
        $(this).removeClass('error').next('.v-message').remove();
    });

    //判断是否为空
    $required.each(function(){
        if(that.isEmpty(this.value) && !$(this).hasClass('error')){
            $(this).addClass('error');
        } 
        that.options[$(this).attr('name')]=this.value;
    });
  },
  isEmpty(str){
    return '' == str.replace(/^\s+|\s+$/,'');
  },
  isPhone(str){
      return (/^1\d{10}$/.test(str));
  },
  isEmail(str){
    return (/^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+.[a-zA-Z]{2,4}$/.test(str))
  },
  isChina(str){
    if (escape(str).indexOf( "%u" ) < 0){
       return 1;
     } else {
       return 2;
    }
  },
  isNumber(n){
    return isNaN(Number(n));
  },
  setCookie(name,value,time){
    var exp = new Date();
    exp.setTime(exp.getTime() + (time*24*60*60*1000));
    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
  },
  getCookie(cname){
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) 
    {
      var c = ca[i].trim();
      if (c.indexOf(name)==0) return c.substring(name.length,c.length);
    }
    return "";
  },
  isMobile(){
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "Windows CE", "BlackBerry");
    var flag = false;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = true; break; }
    }
    return flag;
  }
}
$(()=>{
  _index.init();
});


